"use strict";

// this is in its own file (and removed from app.js) so our unit test configuration can exclude it
angular.module("fleetviewApp").config(["$translateProvider", "alkTranslationLoaderProvider", function ($translateProvider, alkTranslationLoaderProvider) {
  alkTranslationLoaderProvider.$get().load($translateProvider);
}]);


// WEBPACK FOOTER //
// ./app/app.translate.js